module.exports = [
  require('./xvart'),
  require('./xvart_speaker'),
  require('./xvart_warlock_of_raxivort'),
]
